import { C1Icon } from 'components/core/icons/C1Icon'
import { sxc } from 'components/no-ui/styles/styleTypes'
import { Ban, CircleCheck, CircleHelp, CircleMinus } from 'lucide-react'
import React from 'react'
import { styles } from './styles'

type UserStatusIconProps = {
    className?: string
    iconSize?: 'small' | 'inherit' | 'medium' | 'large'
}

const mapIconSize = (iconSize?: 'small' | 'inherit' | 'medium' | 'large'): 'sm' | 'md' | 'lg' | undefined => {
    switch (iconSize) {
        case 'small':
            return 'sm'
        case 'medium':
        case 'inherit':
            return 'md'
        case 'large':
            return 'lg'
        default:
            return undefined
    }
}

export const UserStatusIconEnabled = ({ className, iconSize }: UserStatusIconProps): React.ReactElement => {
    return <C1Icon icon={CircleCheck} size={mapIconSize(iconSize)} aria-label="enabled" className={className} sx={sxc([!className, styles.icon], styles.enabled)} />
}

export const UserStatusIconDisabled = ({ className, iconSize }: UserStatusIconProps): React.ReactElement => {
    return (
        <C1Icon icon={CircleMinus} size={mapIconSize(iconSize)} aria-label="disabled" className={className} sx={sxc([!className, styles.icon], styles.disabled)} />
    )
}

export const UserStatusIconDeleted = ({ className, iconSize }: UserStatusIconProps): React.ReactElement => {
    return <C1Icon icon={Ban} size={mapIconSize(iconSize)} aria-label="deleted" className={className} sx={sxc([!className, styles.icon], styles.deleted)} />
}

export const UserStatusIconUnknown = ({ className, iconSize }: UserStatusIconProps): React.ReactElement => {
    return <C1Icon icon={CircleHelp} size={mapIconSize(iconSize)} aria-label="unknown" className={className} sx={sxc([!className, styles.icon], styles.unknown)} />
}
